import React from "react";
import { useIntl } from "react-intl";
import { Button, MessageBanner, Modal, ModalFooter, } from "@folio/stripes/components";
export var ReinstateDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, onConfirm = _a.onConfirm, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, titleName = _a.titleName, errorMessage = _a.errorMessage;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.enforcement.reinstate.title",
        }), onClose: onClose, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: onConfirm, disabled: isLoading }, formatMessage({ id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: onClose }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement("p", null, formatMessage({ id: "ui-br-legaldeposits.enforcement.reinstate.message" }, { title: titleName !== null && titleName !== void 0 ? titleName : "" })),
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage))));
};
